import type { PartnerContact } from "@stockline/shared/types/crm/partner-contact"
import type { OfflineResourceConfig } from "../../../types"
import { PARTNER_CONTACT_TABLE } from "./db"

export const partnerContactConfig: OfflineResourceConfig<PartnerContact> = {
  name: "partner-contacts",
  endpoints: {
    full: "/api/v2/partner-contacts",
    delta: "/api/v2/partner-contacts/changes",
    push: "/api/v2/partner-contacts/changes",
  },
  tableName: PARTNER_CONTACT_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    partnerId: "partnerId",
    companyOwner: "companyOwner",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
